import './App.css';
import Portfolio from './components/portfolio/portfolio';
function App() {
  return (
    <div className="App">
      <Portfolio></Portfolio>
    </div>
  );
}

export default App;
